var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.bureauId)?_c('attendance-overview-detail',{attrs:{"bureau-id":_vm.bureauId}}):_c('attendance-bureau')],1)}
var staticRenderFns = []

export { render, staticRenderFns }